import { useId } from "react";
import "../../../assets/css/adminForms.css";

export default function AdminFormLayout({ title, description, children }) {
  return (
    <div className="admin-edit-page" dir="rtl">
      <header className="admin-edit-header">
        <span className="admin-edit-eyebrow">مدیریت محتوا</span>
        <h1>{title}</h1>
        {description && <p>{description}</p>}
        <p className="admin-edit-notice">تغییرات پس از ثبت فرم اعمال می‌شوند.</p>
      </header>
      <div className="admin-edit-content">{children}</div>
    </div>
  );
}

export function FormSection({ title, description, children, id }) {
  const generatedId = useId();
  const headingId = id || generatedId;
  return (
    <section className="admin-form-section" aria-labelledby={headingId}>
      <div className="admin-form-section-heading">
        <h2 id={headingId}>{title}</h2>
        {description && <p>{description}</p>}
      </div>
      {children}
    </section>
  );
}
